/**
 * Production run (execução) — an interval of work against an OP
 * (spec 0041 §2.2 / request 0183).
 *
 * Top-level collection: org/{orgId}/production-run (not a subcollection).
 * Transactional: Auditable, no Inactivatable — the only lifecycle is `status`.
 *
 * Anchoring matches ProductionEntry: `productionOrderId` required; `ticketId`
 * optional (org params `requireTicket` / `requireStep` apply here too).
 * No stock-ledger effect — that stays on the apontamento.
 */
export const PRODUCTION_RUN = 'ProductionRun';
export const ProductionRunStatusValues = [
    'running',
    'paused',
    'finished',
    'cancelled',
];
export const PRODUCTION_RUN_STATUS_LABELS = {
    running: 'Em execução',
    paused: 'Pausada',
    finished: 'Encerrada',
    cancelled: 'Cancelada',
};
//# sourceMappingURL=production-run.js.map